<script setup lang="ts">
import Decimal from "decimal.js"
import type { LimitedSubscriptionModel } from "~/utils/generated/api"

const props = defineProps<{
	data: LimitedSubscriptionModel[]
}>()

const emit = defineEmits<{
	go: [id?: string]
}>()

const computedPrice = computed(() => props.data
	.map((item) => {
		const price = new Decimal(item.priceInToman).dividedBy(1000).round()
		const priceInString = price.equals(0) ? "رایگان" : `${price} هزار تومان`
		return {
			originalPrice: price,
			bold: item.bold,
			description: item.description,
			title: item.title,
			features: item.features,
			id: item.id,
			price: priceInString,
			timeDuration: price.equals(0) ? "روزانه" : "ماهانه",
		}
	})
	.sort((a, b) => {
		// If both have the same boldness, check for price
		if (a.originalPrice.equals(0) && !b.originalPrice.equals(0))
			return -1 // 'a' should come first
		if (!a.originalPrice.equals(0) && b.originalPrice.equals(0))
			return 1 // 'b' should come first

		// Check if 'a' is bold and 'b' is not
		if (a.bold && !b.bold)
			return -1 // 'a' should come first
		if (!a.bold && b.bold)
			return 1 // 'b' should come first

		return 0 // Keep original order if both are the same in terms of boldness and price
	}),
)
</script>

<template>
	<div
		data-aos="fade-up"
		class="relative grid mx-auto max-w-910px items-center justify-center gap-5 xl:grid-cols-3 *:min-h-440px xl:gap-0">
		<SubscriptionCard
			v-for="item of computedPrice"
			:id="item.id"
			:key="item.id"
			:bold="item.bold"
			:title="item.title"
			:description="item.description"
			:original-price="item.originalPrice"
			:features="item.features"
			:time-duration="item.timeDuration"
			:price="item.price"
			@go="emit('go', item.id)" />
	</div>
</template>
